import { render } from "./feeSum.vue?vue&type=template&id=dc9a2daa"
import script from "./feeSum.vue?vue&type=script&lang=js"
export * from "./feeSum.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__